import {Group, Text, ThemeIcon, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {CREDIT_TIERS, type EmailType} from './constants';

interface CreditsBannerProps {
  emailType: EmailType;
}

const TIER_HEADLINE: Record<EmailType, string> = {
  edu: 'Academic email verified',
  work: 'Organization email verified',
  personal: 'Free personal plan',
};

/** Compact inline callout showing the real recurring monthly credit allowance for the tier. */
export default function CreditsBanner({emailType}: CreditsBannerProps): JSX.Element {
  const {classes} = useStyles();
  const tier = CREDIT_TIERS[emailType];
  const color = emailType === 'personal' ? 'blue' : 'green';

  return (
    <Group className={classes.banner} noWrap={true} spacing="sm">
      <ThemeIcon color={color} radius="xl" size={24} variant="light">
        <BenchlingIcon icon="check" />
      </ThemeIcon>
      <div>
        <Text fw={600} size="sm">
          {TIER_HEADLINE[emailType]}
        </Text>
        <Text color="dimmed" size="sm">
          {tier.predictionsPerMonth.toLocaleString()} free predictions / month.
        </Text>
      </div>
    </Group>
  );
}

const useStyles = createStyles((theme) => ({
  banner: {
    backgroundColor: theme.colors.gray[0],
    border: `1px solid ${theme.colors.gray[2]}`,
    borderRadius: theme.radius.md,
    padding: theme.spacing.sm,
  },
}));
